import { render, staticRenderFns } from "./storeMappingDetail.vue?vue&type=template&id=d24b5b1e&scoped=true"
import script from "./storeMappingDetail.vue?vue&type=script&lang=js"
export * from "./storeMappingDetail.vue?vue&type=script&lang=js"
import style0 from "./storeMappingDetail.vue?vue&type=style&index=0&id=d24b5b1e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d24b5b1e",
  null
  
)

export default component.exports